import { FC, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDebouncedCallback, useFilterChangeCallback } from 'shared/hooks';
import { selectMortgageMonthlyPaymentFilter } from 'shared/selectors/filters';
import { NumberInput } from '@cian/ui-kit';
import { MortgagePaymentInputAdornment } from './components/MortgagePaymentInputAdornment';
import { TFilter } from 'shared/types/filters';

interface IMortgageMonthlyPaymentFilterProps {
  filterKey?: TFilter;
}

const MAX_VALUE = 1000000000;

export const MortgageMonthlyPaymentFilter: FC<IMortgageMonthlyPaymentFilterProps> = ({ filterKey }) => {
  const { value } = useSelector(selectMortgageMonthlyPaymentFilter);
  const [internalValue, setInternalValue] = useState<number | undefined>(value);

  const onChange = useFilterChangeCallback(filterKey);

  const handleMortgagePaymentChange = useDebouncedCallback((maxPayment: number | null) => {
    onChange({ action: 'setMortgageMonthlyPaymentTo', arguments: [maxPayment] });
  });

  const handleInputChange = useCallback(
    (value: number) => {
      setInternalValue(value);
      handleMortgagePaymentChange(value);
    },
    [handleMortgagePaymentChange],
  );

  return (
    <NumberInput
      value={internalValue}
      onChange={handleInputChange}
      max={MAX_VALUE}
      placeholder="Платёж до"
      rightAdornment={<MortgagePaymentInputAdornment />}
    />
  );
};
